export class ReportFeedbackForm extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.init();
    }

    init() {
        const errors = this.dataset.errors ? JSON.parse(this.dataset.errors) : [];
        if (errors.length > 0) {
            toastr.error(errors.join('<br>'), 'Feedback Request Failed', {
                positionClass: 'toast-bottom-center',
            });
            // grey out the form and disable inputs
            this.style.opacity = '0.5';
            const inputs = this.querySelectorAll('input, textarea, button');
            inputs.forEach(input => {
                input.disabled = true;
            });
        }

        this.initEventListeners();
    }

    initEventListeners() {
        const sendBtn = this.querySelector('.send-btn');
        if (sendBtn) {
            sendBtn.addEventListener('click', this.handleSubmit.bind(this));
        }
    }

    handleSubmit() {
        const reportType = this.dataset.report_type;
        const like = this.dataset.like === '1';
        let marketingAcceptance = false;
        const marketingAcceptanceBtn = this.querySelector('.marketing-acceptance input');
        if (marketingAcceptanceBtn) {
            marketingAcceptance = marketingAcceptanceBtn.checked;
        }
        const reportedBy = this.querySelector('.reported-by').value.trim();
        const feedback = this.querySelector('#feedback').value.trim();
        if (reportedBy.length < 3) {
            toastr.error('Please enter a valid name (at least 3 characters).', 'Missing Input', {
                positionClass: 'toast-bottom-center',
            });
            return;
        }
        if (!like && feedback.length < 10) {
            toastr.error('Please provide more detailed feedback (at least 10 characters).', 'Missing Input', {
                positionClass: 'toast-bottom-center',
            });
            return;
        }

        const formData = new FormData();
        formData.append('reported_by', reportedBy);
        formData.append('marketing_agree', marketingAcceptance ? '1' : '0');
        formData.append('description', feedback);
        formData.append('like', like ? '1' : '0');
        if (reportType === 'ai') {
            const bodyRegionDropdown = this.querySelector('#screening-eval-type-id');
            if (bodyRegionDropdown) {
                const selectedOption = bodyRegionDropdown.options[bodyRegionDropdown.selectedIndex];
                if (!selectedOption || !selectedOption.value) {
                    toastr.error('Please select a region.', 'Missing Input', {
                        positionClass: 'toast-bottom-center',
                    });
                    return;
                }
                formData.append('ai_screening_eval_type_id', selectedOption.value);
            }
            formData.append('case_id', this.dataset.case_id);

        } else {
            formData.append('report_id', this.dataset.report_id);
        }

        fetch('/api/' + reportType + '-report-feedback', {
            method: 'POST',
            headers: {
                accept: 'application/json',
            },
            body: formData
        }).then(response => {
            if (response.ok) {
                toastr.success('Thank you for your feedback!', 'Feedback Sent', {
                    positionClass: 'toast-bottom-center',
                });
                this.resetForm();
            } else {
                response.json().then(data => {
                    if (data && data.errors) {
                        let errorMessages = [];
                        for (const key in data.errors) {
                            if (data.errors.hasOwnProperty(key)) {
                                errorMessages = errorMessages.concat(data.errors[key]);
                            }
                        }
                        toastr.error(errorMessages.join('<br>'), 'Submission Failed', {
                            positionClass: 'toast-bottom-center',
                        });
                    } else {
                        toastr.error('An error occurred while submitting your feedback. Please try again later.', 'Submission Failed', {
                            positionClass: 'toast-bottom-center',
                        });
                    }
                }).catch(() => {
                    toastr.error('An error occurred while submitting your feedback. Please try again later.', 'Submission Failed', {
                        positionClass: 'toast-bottom-center',
                    });
                });
            }
        }).catch(error => {
            toastr.error('An error occurred while submitting your feedback. Please try again later.', 'Submission Failed', {
                positionClass: 'toast-bottom-center',
            });
        });
    }

    resetForm() {
        this.querySelector('.reported-by').value = '';
        this.querySelector('#feedback').value = '';
        let marketingAcceptanceBtn = this.querySelector('.marketing-acceptance input');
        if (marketingAcceptanceBtn) {
            marketingAcceptanceBtn.checked = false;
        }
    }   
}

customElements.define('report-feedback-form', ReportFeedbackForm);